import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { Input } from '@firesoon/antd';
import classnames from 'classnames';
import AntdSearch from '@firesoon/antd/lib/input/Search';
import { FSSearchProps } from './interface';
import './index.less';

const { Search: ASearch } = Input;

const Search: ForwardRefRenderFunction<AntdSearch, FSSearchProps> = (props, ref) => {
  const { className = '', placeholder = '请输入内容', ...rest } = props;

  return (
    <ASearch
      placeholder={placeholder}
      className={classnames(`fs-search ${className}`, {
        'fs-input-not-disabled': !rest?.disabled,
      })}
      ref={ref}
      data-log-userdefined="搜索框"
      allowClear
      {...rest}
    />
  );
};

export default forwardRef(Search);
